import React from "react";
import Dropdown from "../../component/dropdown";
import Sidebar from "../../component/home/sidebar";
import SearchForm from "../../component/search-form";
import FilterButton from "../../component/dropdown-filter";
export default function Plans(props) {
  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <header className="sm:flex sm:justify-between sm:items-center mb-5">
        <div className="mb-4 sm:mb-0">
          <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">
          Account Settings
          </h1>
        </div>
      </header>
      <div
        className="h-full flex flex-col bg-white md:flex-row md:bg-slate-50"
        style={{ height: "100vh" }}
      >
        <Sidebar />
        <div className="flex-auto m-5">Plans</div>
      </div>
    </div>
  );
}
Plans.auth = { path: "/plans", role: "super-admin" };
